module.exports = __webpack_public_path__ + "static/img/20007 (5).16ed446.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20007 (5).webp
// module id = IBgN
// module chunks = 14